import { styled } from '@mui/material';
import MUITooltip, {
  type TooltipProps as MUITooltipProps,
  tooltipClasses,
} from '@mui/material/Tooltip';
import { forwardRef } from 'react';

interface TooltipProps extends MUITooltipProps {
  maxWidth?: number | 'none';
}

const CustomTooltip = forwardRef((props: Readonly<TooltipProps>, ref) => {
  const { placement = 'top', className, ...restProps } = props;

  return (
    <MUITooltip classes={{ popper: className }} placement={placement} {...restProps} ref={ref} />
  );
});

const Tooltip = styled(CustomTooltip, {
  shouldForwardProp: (prop) => prop !== 'maxWidth',
})(({ maxWidth }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: maxWidth ?? 300,
  },
}));

CustomTooltip.displayName = 'Tooltip';

export { Tooltip, tooltipClasses };
export type { TooltipProps };
